import { render, staticRenderFns } from "./StuProveManage.vue?vue&type=template&id=b1da01b2&scoped=true&"
import script from "./stuprovemanage.js?vue&type=script&lang=js&"
export * from "./stuprovemanage.js?vue&type=script&lang=js&"
import style0 from "./StuProveManage.vue?vue&type=style&index=0&id=b1da01b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1da01b2",
  null
  
)

export default component.exports